module.exports = __webpack_public_path__ + "img/logo-goodfood.22176faf.png";